import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';

const CheckboxWrapper = ({ value, onChange, disabled, label }) => {
  return (
    <Checkbox checked={value} onChange={onChange} disabled={disabled}>
      <span className="check_text">{label}</span>
    </Checkbox>
  );
};

export default CheckboxWrapper;
